export { SixteenArrowsDirectionsRight33 } from "./SixteenArrowsDirectionsRight33";
